import { TableViewTypes } from './actionTypes';

const INIT_STATE = {
  items: [],
  action: '',
  success: '',
  error: {},
};

const tableViews = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case TableViewTypes.GET_TABLE_VIEWLIST:
      return {
        ...state,
        action: '',
        success: '',
        error: {},
      };
    case TableViewTypes.GET_TABLE_VIEWLIST_SUCCESS:
      return {
        ...state,
        items: action.payload,
      };
    case TableViewTypes.GET_TABLE_VIEWLIST_FAIL:
      return {
        ...state,
        items: [],
        error: action.payload,
      };

    case TableViewTypes.CREATE_TABLE_VIEW:
      return {
        ...state,
      };
    case TableViewTypes.CREATE_TABLE_VIEW_SUCCESS:
      return {
        ...state,
        action: 'create',
        success: action.payload.success,
        error: action.payload.errorMessage,
      };
    case TableViewTypes.CREATE_TABLE_VIEW_FAIL:
      return {
        ...state,
        action: '',
        success: action.payload.success,
        error: action.payload.errorMessage,
      };

    case TableViewTypes.UPDATE_TABLE_VIEW:
      return {
        ...state,
      };
    case TableViewTypes.UPDATE_TABLE_VIEW_SUCCESS:
      return {
        ...state,
        action: 'update',
        success: action.payload.success,
        error: action.payload.errorMessage,
      };
    case TableViewTypes.UPDATE_TABLE_VIEW_FAIL:
      return {
        ...state,
        action: '',
        success: action.payload.success,
        error: action.payload.errorMessage,
      };

    case TableViewTypes.DELETE_TABLE_VIEW:
      return {
        ...state,
      };
    case TableViewTypes.DELETE_TABLE_VIEW_SUCCESS:
      return {
        ...state,
        action: 'delete',
        success: action.payload.success,
        error: action.payload.errorMessage,
      };
    case TableViewTypes.DELETE_TABLE_VIEW_FAIL:
      return {
        ...state,
        action: '',
        success: action.payload.success,
        error: action.payload.errorMessage,
      };

    default:
      break;
  }
  return state;
};

export default tableViews;
